const initialState = {
  message: null,
  isError: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_NOTIFICATION': {
      const { message, isError } = action.payload;
      return {
        ...state,
        message,
        isError
      };
    }
    case 'CLEAR_NOTIFICATION': {
      return {
        ...state,
        ...initialState
      };
    }
    default:
      return state;
  }
};

export default reducer;
